import axios from '@/utils/axios'
import {business, doctorPrefix} from '@/api/common'

/**
 * 分页查询会员信息
 *
 * @param pageInfo
 * @returns {AxiosPromise}
 */
export const memberList = (pageInfo, params) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/memberList`,
    method: 'post',
    data: pageInfo,
    params: params
  })
}

/**
 * 查询患者档案
 */
export const patientList = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/patientList`,
    method: 'post',
    data: params
  })
}

/**
 * 添加患者档案前(0: 不存在，1：存在)
 */
export const beforeAddPatient = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/beforeAddPatient`,
    method: 'post',
    data: params
  })
}
/**
 * 添加患者档案
 */
export const addPatient = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/addPatient`,
    method: 'post',
    data: params
  })
}
/**
 * 根据患者编码查询患者关系标签列表
 */
export const patientRelationTagList = (memberCode) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/patientRelationTagList`,
    method: 'get',
    params: { memberCode }
  })
}

/**
 * 查询患者关系列表
 */
export const patientRelationList = (patientCode) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/patientRelationList`,
    method: 'get',
    params: { patientCode }
  })
}

/**
 * 绑定患者家庭成员
 */
export const bindPatientRelation = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/bindPatientRelation`,
    method: 'post',
    data: params
  })
}

/**
 * 查询患者标签列表
 */
export const patientTagList = () => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/patientTagList`,
    method: 'get'
  })
}

/**
 * 添加患者标签
 */
export const addPatientTags = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/addPatientTags`,
    method: 'post',
    data: params
  })
}

/**
 * 获取当前患者标签
 */
export const getPatientTags = (patientCode) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/getPatientTags`,
    method: 'get',
    params: { patientCode }
  })
}

/**
 * 获取患者医案性别分布
 * @returns {AxiosPromise}
 */
export const getMedicalTypeStatistics = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/statistics/getMedicalTypeStatistics`,
    method: 'post',
    data: params
  })
}

/**
 * 获取患者所有状态统计
 * @returns {AxiosPromise}
 */
export const getPatientAllStateStatistics = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/getPatientAllStateStatistics`,
    method: 'post',
    data: params
  })
}

/**
 * 获取当前患者病历
 */
export const medicalRecordList = (pageInfo, queryParam) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/medical/medicalRecordListByPatient`,
    method: 'post',
    data: pageInfo,
    params: queryParam
  })
}
/**
 * 获取当前患者订单记录
 */
export const patientOrderPage = (pageInfo, queryParam) => {
  return axios({
    url: `${business}${doctorPrefix}/medicine/order/patientOrderPage`,
    method: 'post',
    data: pageInfo,
    params: queryParam
  })
}
/**
 * 获取当前患者订单记录
 */
export const getTreatPageByPatientCode = (pageInfo, queryParam) => {
  return axios({
    url: `${business}${doctorPrefix}/medicine/treat/getTreatPageByPatientCode`,
    method: 'post',
    data: pageInfo,
    params: queryParam
  })
}

/**
 * 获取当前诊所医生
 */
export const getDoctorList = () => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/getDoctorList`,
    method: 'get'
  })
}

/**
 * 获取未绑定会员的患者列表
 */
export const noMemberPatientList = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/noMemberPatientList`,
    method: 'post',
    data: params
  })
}

/**
 * 从患者处添加会员
 */
export const addMember = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/addMember`,
    method: 'post',
    data: params
  })
}
/**
 * 创建充值订单
 */
export const createOrder = (memberId, amount) => {
  return axios({
    url: `${business}${doctorPrefix}/member/wallet/createOrder`,
    method: 'post',
    params: {
      memberId,
      amount
    }
  })
}
/**
 * 发起支付
 */
export const launchPay = (orderSn, payType, phone, pwd) => {
  return axios({
    url: `${business}${doctorPrefix}/member/wallet/launchPay`,
    method: 'post',
    params: {
      orderSn,
      payType,
      phone,
      pwd
    }
  })
}
/**
 * 查找或创建会员钱包
 * @param memberId
 */
export const getWallet = (memberId) => {
  return axios({
    url: `${business}${doctorPrefix}/member/wallet/getWallet`,
    method: 'post',
    params: {
      memberId
    }
  })
}
/**
 * 查看会员钱包操作记录
 * @param pageInfo
 * @param query
 */
export const optLog = (pageInfo, query) => {
  return axios({
    url: `${business}${doctorPrefix}/member/wallet/optLog`,
    method: 'post',
    data: pageInfo,
    params: query
  })
}
/**
 * 查看会员流水记录
 * @param pageInfo
 * @param query
 */
export const flowLog = (pageInfo, query) => {
  return axios({
    url: `${business}${doctorPrefix}/member/wallet/flowLog`,
    method: 'post',
    data: pageInfo,
    params: query
  })
}
/**
 * 医生端获取患者绑定会员信息
 *
 * @param patientCode
 * @return
 */
export const getMemberInfo = (patientCode) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/getMemberInfo`,
    method: 'get',
    params: {
      patientCode
    }
  })
}
/**
 * 医生端绑定患者到该会员处
 *
 * @param memberCode
 * @param patientCode
 * @param relation
 * @return
 */
export const bindMember = (memberCode, patientCode, relation) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/bindMember`,
    method: 'post',
    params: {
      memberCode,
      patientCode,
      relation
    }
  })
}

/**
 * 删除该会员下绑定的患者
 *
 * @param patientCode
 */
export const unbindMember = (patientCode) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/unbindMember`,
    method: 'post',
    params: {
      patientCode
    }
  })
}

/**
 * 获取租户模式下会员户主患者信息
 *
 * @param memberCode 会员编码
 * @param clinicCode 诊所编码
 */
export const getHostPatientForTenantMember = (memberCode, clinicCode) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/getHostPatientForTenantMember`,
    method: 'post',
    params: {
      memberCode,
      clinicCode
    }
  })
}

/**
 * 从其他诊所创建会员户主
 *
 * @param memberCode 会员编码
 * @param clinicCode 诊所编码
 */
export const createMemberHost = (memberCode, clinicCode) => {
  return axios({
    url: `${business}${doctorPrefix}/member/manager/createMemberHost`,
    method: 'post',
    params: {
      memberCode,
      clinicCode
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/business/doctor/member-manager/index.js